import shortenWebsiteLink from "./shortenWebsiteLink";

export default shortenWebsiteLink;
